import { SystemActions, NavigationActions } from "@ignitesales/neuro-application";
import { RegionsConsumerOnlineActions, focusedPathKey } from '../actions/regions-consumer-online-actions.mjs';

const regionsOnlineConsumerReducer = (state, action) => {
  switch (action.type) {
    case RegionsConsumerOnlineActions.PREFERRED_PATH_UPDATE_COMPLETED: {
      const { url } = action;
      return {
        ...state,
        redirectToPath: url,
        redirectType: 'path'
      }
    }

    case SystemActions.APP_READY: {
      const focusedPath = window.sessionStorage.getItem(focusedPathKey);
      if( focusedPath && !window.location.pathname.includes(`/${focusedPath}/`)) {
        window.sessionStorage.removeItem(focusedPathKey);
      }
      return {
        ...state,
      }
    }

    case RegionsConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED: {
      return {
        ...state,
        regionsAppIsReady: true
      }
    }

    case NavigationActions.PAGE_REQUEST_COMPLETED: {
      const { nextPage } = action;
      const { user } = state;
      const focusedPath = window.sessionStorage.getItem(focusedPathKey);
      if( focusedPath && nextPage?.page?.path?.key !== focusedPath ) {
        return {
          ...state,
          redirectToPath: `/guide/${user.uuid}/summary`,
          redirectType: 'summary'
        }
      } else {
        return {
          ...state
        }
      }
    }

    default:
      return state;
  }
}

export default regionsOnlineConsumerReducer;
